import { RefObject, useEffect, useState } from 'react';

const useIsVisible = (ref: RefObject<HTMLDivElement>) => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(([entry]) =>
      setIntersecting(entry.isIntersecting)
    );

    observer.observe(ref.current);
    // eslint-disable-next-line consistent-return
    return () => observer.disconnect();
  }, [ref]);

  return isIntersecting;
};

export default useIsVisible;
